import { useMemo } from 'react'
import { FiTrendingUp } from 'react-icons/fi'

import CardIcon from '~/components/cards/card-icon'
import { formatDateToString } from '~/helpers'
import i18n from '~/i18n'
import { useAppSelector } from '~/store/hooks'

const Card = ({
  title,
  value,
  loading,
  icon,
  showInterval = true,
  isRelativeInterval = true,
  compareValue,
  compareInterval,
  isCompare = false,
  badgeOverride
}) => {
  const { startDate, endDate } = useAppSelector(state => state.datepickerHeader)

  const selectedIinterval = useMemo(() => {
    const start = formatDateToString(
      startDate,
      i18n.t('common:patterns.dateMonth')
    )
    const end = formatDateToString(endDate, i18n.t('common:patterns.dateMonth'))

    const interval = `${start} - ${end}`

    return interval
  }, [endDate, startDate])

  const selectedCompareInterval = useMemo(() => {
    if (!compareInterval) return null

    const start = formatDateToString(
      compareInterval.startDate,
      i18n.t('common:patterns.dateMonth')
    )
    const end = formatDateToString(
      compareInterval.endDate,
      i18n.t('common:patterns.dateMonth')
    )

    const interval = `${start} - ${end}`

    return interval
  }, [compareInterval])

  const badgeValue =
    badgeOverride ??
    (isRelativeInterval ? selectedIinterval : i18n.t('rm:Today'))

  return (
    <CardIcon
      title={title}
      value={value}
      loading={loading}
      icon={icon || <FiTrendingUp className="text-primary" />}
      {...(isCompare && showInterval ? { compareValue } : {})}
      {...(isCompare && showInterval && isRelativeInterval
        ? { compareInterval: selectedCompareInterval }
        : {})}
      {...(showInterval ? { badge: badgeValue } : {})}
    />
  )
}

export default Card
